module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.a99d8db.woff";